module.exports = __webpack_public_path__ + "media/images/city_img/j_3-c676dedd539e5b052c068a1353abbd8a.jpg";